import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import PageSubHeader from '../../components/common/page_sub_header'
import {MenuMy} from '../../config/page_route'
import {customDateFormat, drawTableTitleCell, drawTableArticleType,formatNumber} from '../../helper/common'
import TabHeader from '../../components/control/table/tab_header'
import PerfectScrollbar from 'react-perfect-scrollbar'
import TableHeader from '../../components/control/table/table_header'
import TableCell from '../../components/control/table/table_cell'
import ReactPaginate from 'react-paginate'
import {PAGECOUNT} from '../../config/const'
import {rootStore} from '../../mobx/store'
import tbAnalystHeaders, {tbGameHeaders, tbBjHeaders, tbDailyHeaders, tabInfo} from '../../config/constTable'

const PayList = observer((props) => {
  const context = useContext(Page_settings)
  let [tabIndex, setTabIndex] = useState(0)
  const tabList = [tabInfo.bjGameArticle]
  let [dataList, setDataList] = useState(Array.from({ length: tabList.length }, () => []))
  let [pageCount, setPageCount] = useState(Array.from({ length: tabList.length }, () => 1))
  let [page, setPage] = useState(Array.from({ length: tabList.length }, () => 1))


  const active = 5

  const tbHeaders = [
    {
      name: strings.num,
      class: 'td-pur-num',
    },
    {
      name: strings.buy_date,
      class: 'td-pur-buy-date',
    },
    {
      name: strings.title,
      class: 'td-pur-title color-4c4c4d text-line',
    },
    {
      name: strings.analyst_member,
      class: 'td-pur-member',
    },
    {
      name: strings.used_point,
      class: 'td-pur-point',
      divider: false
    },
  ]

  useEffect(() => {
    getData(1, 0)
  }, [])

  const getData = (page, index) => {
    context.post('pay/pay_list', {cate: tabList[index].cate, page: page, count: PAGECOUNT},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        setDataList(prev => prev.map((it, idx) => {return idx === index ? response.list : it}))
        setPageCount(prev => prev.map((it, idx) => {return idx === index ? response.page_count : it}))
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const onDetail = (result) => {
    props.history.push(tabList[tabIndex].url, {result: result})
  }

  const handlePageClick = (component) => {
    let nextPage = component.selected + 1
    setPage(prev => prev.map((it, idx) => {return idx === tabIndex ? nextPage : it}))
    getData(nextPage, tabIndex)
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft menu={MenuMy} active={active} history={props.history} />
        <div className='im-container'>
          <PageSubHeader pageName={strings.mypage} pageMenu1={strings.main} pageMenu2={strings.mypage} pageMenu={strings.pay_list}/>
          <div className='term-content-area'>
            <div className='fs-20 sm-fs-16 f-b'>{strings.analyst_data}</div>
            <TabHeader className={'mt-30 pay-list-header sm-none'} selected={tabIndex} tabs={tabList.map(item => item.customTitle || item.title )} onChange={(id) => {setTabIndex(id)}}/>
            <select className='form-control sm-mt-15 sm-inherit custom_select' value={tabIndex} onChange={(e) => {setTabIndex(parseInt(e.target.value))}}>
              {tabList.map((it, idx) => {return (<option value={idx} key={idx}>{it.title}</option>)})}
            </select>
            {tabList.map((it, idx) => {return (
              <div key={idx} className={tabIndex === idx ? '' : 'hide'}>
                <div className='shadow-div position-relative'>
                  <PerfectScrollbar className='div_sale sm-mt-20 mb-40'>
                    <TableHeader className={'bg-white'} headers={tbHeaders}/>
                    {
                      dataList[idx].map((info, index) => {
                        return (
                          <div key={index} className='tb-row clickable-row-highlight cursor-point' onClick={() => {onDetail(info)}}>
                            <TableCell
                              value={(page[idx] - 1) * PAGECOUNT + index + 1}
                              className={tbHeaders[0].class}
                              center={tbHeaders[0].center}
                              child={null}
                            />
                            <TableCell
                              value={customDateFormat(info.dat_updatedat)}
                              className={tbHeaders[1].class}
                              center={tbHeaders[1].center}
                              child={null}
                            />
                            <TableCell
                              value={info.dat_title}
                              className={`${tbHeaders[2].class} hover-text-accent`}
                              center={tbHeaders[2].center}
                              child={drawTableTitleCell(info.dat_title, info.data_new)}
                            />
                            <TableCell
                              value={info.mb_nick}
                              className={tbHeaders[3].class}
                              center={tbHeaders[3].center}
                              child={null}
                            />
                            <TableCell
                              value={formatNumber(info.buy_po) + strings._p}
                              className={tbHeaders[4].class}
                              center={tbHeaders[4].center}
                              child={null}
                            />
                          </div>
                        )
                      })
                    }
                  </PerfectScrollbar>
                </div>
                {pageCount[idx] > 1 &&
                <ReactPaginate
                  previousLabel={''}
                  nextLabel={''}
                  breakLabel={'...'}
                  breakClassName={'break-me'}
                  pageCount={pageCount[idx]}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination'}
                  subContainerClassName={'pages pagination'}
                  activeClassName={'active'}
                />
                }
              </div>
            )})}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(PayList)
